<template lang="pug">
  .user-transfer
    v-fade-transition(leave-absolute)
      v-chip(
        v-if="user.record.group && !enrollMode"
        color="secondary"
        @click="setEnrollMode"
      ).pa-5
        span Состоит в «{{ user.record.group.short_name }}»
        v-icon(
          size=28
        ).ml-2 mdi-pencil-circle
    div(v-if="!(user.record.group && !enrollMode)")
      v-select.d-inline-block(
        v-model="newGroup"
        :items="groupsExcludedMy"
        :no-data-text="noDataText"
        :placeholder="!user.record.group ? 'Не зачислен' : 'Перевести'"
        item-text="short_name"
        rounded
        persistent-hint
        filled
        dense
        hide-details
        return-object
      )
      v-btn(
        v-if="user.record.group && enrollMode"
        fab
        small
        depressed
        @click="enrollMode = false"
      ).ml-2
        v-icon mdi-close
      v-btn.ml-2(
        v-if="newGroup"
        light
        color="success"
        depressed
        rounded
        :loading="loading"
        @click="user.record.group ? transferUser() : checkDuplicates()"
      )
        v-icon(left) mdi-account-arrow-right
        span(v-if="user.record.group") Перевести
        span(v-else) Зачислить

    portal(to="duplicates.dialog" v-slot="{ close, attrs }")
      v-sheet(height="100%")
        v-list-item
          v-list-item-icon.mr-3: v-icon(color="error") mdi-alert
          v-list-item-title.text-h6 Найдены дубликаты
          v-list-item-action: v-btn(icon @click="close"): v-icon mdi-close
        duplicates(
          :duplicates="attrs.duplicates"
          @success="enrollUser"
          @close="close"
        )
</template>

<script>
import Duplicates from './Duplicates.vue';

export default {
  components: { Duplicates },
  props: {
    enrollment: { type: Object, required: true },
    user: { type: [Object, Array], required: true },
    groups: { type: Array, required: true },
  },
  data() {
    return {
      newGroup: null,
      enrollMode: false,
      loading: false,
    };
  },
  computed: {
    groupsExcludedMy() {
      if (this.user.record.group) {
        return this.groups.filter((group) => group.id !== this.user.record.group.id);
      }
      return this.groups;
    },
    noDataText() {
      if (this.user.record.group) return 'Нет доступных групп для перевода';
      return 'Нет доступных групп для зачисления';
    },
  },
  watch: {
    user() {
      this.reset();
    },
  },
  methods: {
    reset() {
      this.newGroup = null;
      this.enrollMode = false;
    },
    async transferUser() {
      this.loading = true;
      await this.user.setGroup(this.newGroup);
      this.reset();
      this.loading = false;
    },
    async checkDuplicates() {
      const params = {
        expand: 'attributes,statements,payment_percent',
      };
      const { data } = await this.$api.enrollments.checkDuplicates(this.user.id, params);
      if (data.data.length) {
        this.$modals.show('dialog-portal', {
          inputValue: 'duplicates',
          duplicates: data.data,
        });
      } else this.enrollUser();
    },
    async enrollUser() {
      this.loading = true;
      await this.user.enroll(this.newGroup);
      this.loading = false;
      this.reset();
    },
    setEnrollMode() {
      this.enrollMode = true;
    },
  },
};
</script>
